module.exports = __webpack_public_path__ + "assets/img/middle-bg.5b67e5a4.png";